import apiClient from './apiClient';

export const getCronStatus     = () => apiClient.get('/cron-status/').then(r => r.data);
export const runBnrRates       = () => apiClient.post('/bnr-rates/run/', {}).then(r => r.data);
export const listExchangeRates = () => apiClient.get('/exchange-rates/').then(r => r.data);
export const runLitigiiSync    = () => apiClient.post('/litigii-sync/run/', {}).then(r => r.data);
export const runDailyReport    = () => apiClient.post('/daily-report/run/', {}).then(r => r.data);
export const runAutoTasks      = () => apiClient.post('/auto-tasks/run/', {}).then(r => r.data);
export const runPontajReminders = () => apiClient.post('/pontaj/reminders/run/', {}).then(r => r.data);
export const runMandatariReport = () => apiClient.post('/mandatari-report/run/', {}).then(r => r.data);
